import { AfterViewInit, Component, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeHtmlUtils } from '../../../utils/safe-html.util';
import { DocumentService } from 'src/app/services/document/document.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { DonneesBioLigne } from 'src/app/utils/interfaces/new/DonneesBioLigne';
import { DonneesBioValue } from 'src/app/utils/interfaces/new/DonneesBioValue';
import { MessageReleveBio } from 'src/app/utils/interfaces/new/MessageReleveBio';
import { MessageReleveBioHTML } from 'src/app/utils/interfaces/new/MessageReleveBioHTML';

interface DonneesBioValueToDisplay extends DonneesBioValue {
  displayed?: boolean;
}


@Component({
  selector: 'app-apercu-crbio',
  templateUrl: './apercu-crbio.component.html',
  styleUrls: ['./apercu-crbio.component.scss',
              '../modal.fragment.scss']
})
export class ApercuCrbioComponent implements OnInit, AfterViewInit {

  infoReleve: MessageReleveBio;
  ongletActif = 'details';
  messageId: string;
  documentId: string;

  public closeEmitter = new EventEmitter();
  safeHtml: any;

  constructor(private domSanitizer: DomSanitizer,
    private _mssSrv: MssServiceFactory,
    private _modalService: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _documentSrv: DocumentService,
    ) { }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.initSwitchableValues();
  }

  initSwitchableValues() {
    //Ajout traitement de l'affichage des valeur en Code HTML et des displayName trop grand 
    // afin d'éviter un traitement supplementaire du tableau on le fait ici car on parse deja tout le tableau
    for(const categorie of this.infoReleve.donneesBio.categories) {
      for(const ligne of categorie.lignes) {
        if(ligne.displayName){
          const index = ligne.displayName.indexOf("[");
          ligne.displayName = index !== -1 ? ligne.displayName.slice(0, index) : ligne.displayName;
          ligne.displayName = ligne.displayName.replace(/┼/g, "É");
        }
        for(const value of ligne.values) {
          if(!value.translation) {
            (value as DonneesBioValueToDisplay).displayed = true;
          }
          if (value.referenceRange?.high && value.value) {
            if (Number(value.value) > Number(value.referenceRange.high)) {
              (ligne as any).isError = true;
            }
          }
          if (value.referenceRange?.low && value.value) {
            if (Number(value.value) < Number(value.referenceRange.low)) {
              (ligne as any).isError = true;
            }
          }
          if (value.low && value.referenceRange?.low) {
            if (Number(value.low) < Number(value.referenceRange.low)) {
              (ligne as any).isError = true;
            }
          }
          if (value.high && value.referenceRange?.high) {
            if (Number(value.high) > Number(value.referenceRange.high)) {
              (ligne as any).isError = true;
            }
          }
          if (ligne.interpretationCode &&
            (ligne.interpretationCode.code === 'A' || ligne.interpretationCode.code === 'H' ||
            ligne.interpretationCode.code === 'L')) {
            (ligne as any).isError = true;
          }
          if (ligne.interpretationCode &&
            (ligne.interpretationCode.code === 'AA' || ligne.interpretationCode.code === 'HH' ||
            ligne.interpretationCode.code === 'LL')) {
            (ligne as any).isCriticalError = true;
          }
          if (value.unit) {
            value.unit = this.replaceHtmlEntities(value.unit);
          }
        }
      }
    }
  }

  //remplacer les caractere spéciaux à faire évoluer si d'autre
  replaceHtmlEntities(text: string): string {
    return text
      .replace(/&lt;/g, '<') 
      .replace(/&gt;/g, '>') 
      .replace(/&amp;/g, '&') 
      .replace(/&amp;#181;|&#181;/g, "µ") 
      .replace(/&amp;#233;|&#233;/g, "é")
      .replace(/&amp;#231;|&#231;/g, "ç")
      .replace(/&amp;#251;|&#251;/g, "û")
      .replace(/&amp;#224;|&#224;/g, "à")
      .replace(/&amp;#232;|&#232;/g, "è"); 
  }

  switchValue(selectEvent:Event, ligne:DonneesBioLigne){
    const value  = (selectEvent.currentTarget as HTMLSelectElement).value;
    for(const v of ligne.values) {
      if(v.unit == value) {
        (v as DonneesBioValueToDisplay).displayed = true;
      } else {
        (v as DonneesBioValueToDisplay).displayed = false;
      }
    }
  }

  closeModal() {
    this.closeEmitter.emit();
  }

  async switchTo(onglet: string) {
    this.ongletActif = onglet;
    if (this.ongletActif === "iframe" && !this.safeHtml) {
      const loadingModal = this._modalService.openLoading(this._viewContainerRef);
      let apercuHTML: MessageReleveBioHTML | undefined = undefined;
      if (this.messageId) {
        apercuHTML = await this._mssSrv.getService().getBioMessageReleveHTML(this.messageId);
      } else if (this.documentId) {
        apercuHTML = await this._documentSrv.getCrBioDonneesHtmlByDocumentId(this.documentId);
      }

      if (!apercuHTML) {
        return;
      }

      this.safeHtml = SafeHtmlUtils.sanitizeHtmlAndBypass(apercuHTML.apercuHTML, this.domSanitizer);
      this._modalService.close(loadingModal);
    }
  }

  unescapeHTML(html: string) {
    var e = document.createElement('div');
    e.innerHTML = html;
    return e.childNodes[0].nodeValue;
  }
}
